// extracted by mini-css-extract-plugin
export default {"container":"gallery_container__L4B0l","subtitle":"gallery_subtitle__3T4pv","title":"gallery_title__LLwVk","image":"gallery_image__M2qQF"};